module.exports = __webpack_public_path__ + "static/media/whatsapp.95db6e38.svg";